/**
 * 轮询节奏。
 *
 * 关键认知：**前端轮询不负责推进任务，只负责「把结果取回来」**。
 * 任务真正在推进是后端调度器干的（默认每 5s 查一次上游，见后端 app/scheduler.py）；
 * 前端这个请求只是读库里已经写好的状态 —— 后端 `_poll` 是纯读 SQLite，
 * **完全不碰上游**。所以间隔跟「任务多久出结果」无关，
 * 只影响「结果出来后你还要等多久才看到」。
 *
 * **只有一档：60s。**（用户 2026-09-30 原话：「这个是轮询任务，1分钟查一次就可以」）
 *
 * 这里原来还有「尾段收紧到 5s」的一档（本地估算进度 > 92%，或实际耗时超过估算 1.2 倍）。
 * 删掉它的理由是它在**视频**上从来没起过好作用：
 * 视频估算值是 240s（`ESTIMATED_MS.videoAudio3d`），而贰春实测要 13–15 分钟，
 * 「超过估算 1.2 倍」从第 4.8 分钟起就一直成立 —— 整个任务期都按 5s 打，
 * 一条任务几百次请求，换来的只是「最多早 55 秒看到已完成」。
 * 估算值本来就是猜的，拿它当节拍依据 = 把猜测当事实。
 */

/** 状态确认间隔：**60s**，唯一的网络轮询节拍 */
export const STATE_POLL_MS = 60_000

/**
 * 空闲时的循环节拍：手上没有活跃任务。
 *
 * 这个值不能跟 STATE_POLL_MS 一样大。踩过的坑：submit() 里叫醒同步循环时，
 * React 的 setJobs 还没 re-render，jobsRef 里看不到新任务 → 循环认为「没有活」，
 * 一睡就是 1 分钟，新任务的第一次状态确认被推迟到 60s 后。
 * 空闲节拍短一点，新任务最多晚 IDLE_POLL_MS 被捡起来（这轮全是本地判断，零网络）。
 */
export const IDLE_POLL_MS = 5_000

/** 进度条本地推进间隔：纯本地计算，零网络请求，所以可以快 */
export const PROGRESS_TICK_MS = 1_000

/**
 * 新任务提交后多久做**第一次**确认（3s）。
 *
 * 这是全流程里**唯一**早于 60s 的一次真实请求，刻意留着：余额不足 / Key 失效 /
 * 参数被上游当场拒掉这类失败是**立即**发生的，等到 60s 才报出来，
 * 用户会以为「点了提交没反应」。之后每一次确认都是 60s。
 */
export const FIRST_SYNC_MS = 3_000
